// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"ModalCloseButton_closeButton__xJhIE"};